// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';

function handleChange() {

    this.onChange(!this.isSelected);

}

const LabeledCheckbox = props =>
    <LabeledFormInput
        className={props.className}
        label={props.label}
    >
        {props.isEditable ?
            <Checkbox
                id={props.id}
                onChange={props::handleChange}
                selected={props.isSelected}
            >
                {''}
            </Checkbox> :
            <FormattedMessage id={props.translationId}/>
        }
    </LabeledFormInput>;

LabeledCheckbox.displayName = 'LabeledCheckbox';
LabeledCheckbox.propTypes = {
    className: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    isEditable: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    translationId: PropTypes.string.isRequired
};

export default LabeledCheckbox;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-checkbox.js